import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'
import type { BorrowerPrescreenDto } from '@/types/borrower-prescreen-dto'

type AwaitingCoBorrowerProps = {
  prescreen: BorrowerPrescreenDto
  onResend: () => Promise<void>
  onRemove: () => Promise<void>
  busy?: boolean
  message?: string | null
  error?: string | null
}

export function AwaitingCoBorrower({
  prescreen,
  onResend,
  onRemove,
  busy,
  message,
  error
}: AwaitingCoBorrowerProps) {
  const co = prescreen.coBorrower
  const name = co ? `${co.firstName} ${co.lastName}`.trim() : 'your co-borrower'

  return (
    <div className="space-y-4">
      <Alert>
        <AlertDescription>
          We sent a consent link to {co?.email ?? 'your co-borrower'}. Once {name} completes their
          soft credit check, we will finish your prequalification.
        </AlertDescription>
      </Alert>
      {message && (
        <Alert>
          <AlertDescription>{message}</AlertDescription>
        </Alert>
      )}
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button type="button" variant="outline" disabled={busy} onClick={() => void onResend()}>
          Resend invitation
        </Button>
        {co?.status === 'pending_consent' && (
          <Button type="button" variant="ghost" disabled={busy} onClick={() => void onRemove()}>
            Remove co-borrower
          </Button>
        )}
      </div>
    </div>
  )
}
